import { ColDef } from "ag-grid-enterprise";
import { DataTableImageWithDialog } from "../../reviewDataTable/cellRendererComponents/DataTableImageWithDialog";
import { numberFormatter } from "../../reviewDataTable/utils/valueFormatters";

export function createColumnDefinitions(): ColDef[] {
  return [
    {
      headerName: "Rank",
      field: "computedRank",
      suppressHeaderMenuButton: true,
      suppressHeaderFilterButton: true,
      sortable: false,
      maxWidth: 60,
      valueFormatter: (params) => {
        if (params.node?.aggData) {
          return "Total";
        }
        return params.value;
      }
    },
    {
      headerName: "Image",
      field: "appretio_thumbnail_url",
      cellRenderer: DataTableImageWithDialog,
      suppressHeaderMenuButton: true,
      suppressHeaderFilterButton: true,
      sortable: false
    },

    {
      headerName: "Style Option Id",
      field: "style_option_id_mockup",
      suppressHeaderMenuButton: true,
      suppressHeaderFilterButton: true,
      sortable: false
    },
    {
      headerName: "NS III (OD)",
      field: "ns3",
      headerTooltip: "Net Sales: GS II (OD) - GR II (OD)",
      valueFormatter: numberFormatter,
      suppressHeaderMenuButton: true,
      suppressHeaderFilterButton: true,
      sortable: false,
      aggFunc: "sum"
    },
    {
      headerName: "NIS III (OD)",
      field: "nis3",
      headerTooltip: "GIS I - GIR - Net Items Sales",
      suppressHeaderMenuButton: true,
      suppressHeaderFilterButton: true,
      sortable: false,
      aggFunc: "sum"
    },
    {
      headerName: "ST",
      field: "st",
      valueFormatter: numberFormatter,
      suppressHeaderMenuButton: true,
      suppressHeaderFilterButton: true,
      sortable: false,
      aggFunc: "sum"
    },
    {
      headerName: "TIME PURCHASE",
      field: "time_purchase",
      suppressHeaderMenuButton: true,
      suppressHeaderFilterButton: true,
      sortable: false,
      valueFormatter: numberFormatter,
      aggFunc: "sum"
    },
    {
      headerName: "RRP EUR",
      field: "style_recommended_retail_price_eur",
      suppressHeaderMenuButton: true,
      suppressHeaderFilterButton: true,
      sortable: false,
      valueFormatter: numberFormatter,
      aggFunc: "sum"
    }
  ] satisfies ColDef[];
}
